(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FreshdeskCreateTicket',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			Adzuki.StatusMessage('Success', 'The ticket has been created.');

			$('.modal').modal('hide');
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error creating ticket');
		return false;
	};

}(jQuery, window.Adzuki || {}));
